import 'url-search-params-polyfill';
import isWindow from 'Common/isWindow';
import isWindowProp from 'Common/isWindowProp';

export default params => {
  if (isWindow() && isWindowProp('location') && isWindowProp('history')) {
    let searchParams = new URLSearchParams(window.location.search);
    params.forEach(({ key, val }) => {
      searchParams.set(key, val.toString());
    });

    let newRelativePathQuery =
      window.location.pathname + '?' + searchParams.toString();
    history.pushState(null, '', newRelativePathQuery);
  }
};



// WEBPACK FOOTER //
// ./src/Common/updateQueryString/index.js